"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActionIcon;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalization = require("@planday-corp/globalization");
var _Tooltip = _interopRequireDefault(require("../../overlays/tooltips/Tooltip"));
var _Icon = _interopRequireDefault(require("../../icons/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var COLORS = {
  default: {
    default: 'grey50',
    hover: 'grey80',
    active: 'blue50'
  },
  warning: {
    default: 'red50',
    hover: 'grey80',
    active: 'red30'
  },
  inverted: {
    default: 'white',
    hover: 'grey30',
    active: 'blue30'
  },
  disabled: {
    default: 'grey30',
    hover: 'grey30',
    active: 'grey30'
  }
};
var ClickableIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "ActionIcon__ClickableIcon",
  componentId: "sc-z88gr8-0"
})(["cursor:pointer;pointer-events:", ";"], function (props) {
  return props.$isDisabled ? 'none' : 'auto';
});
function ActionIcon(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    tabIndex = _ref.tabIndex,
    onClick = _ref.onClick,
    label = _ref.label,
    iconName = _ref.iconName,
    className = _ref.className,
    isDisabled = _ref.isDisabled;
  var colors = COLORS[type];
  var _useContext = (0, _react.useContext)(_globalization.GlobalizationContext),
    i18n = _useContext.i18n;
  var iconProps = {
    role: 'button',
    color: colors.default,
    hoverColor: colors.hover,
    activeColor: colors.active
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (!isDisabled && (event.key === ' ' || event.key === 'Enter')) {
      onClick(event);
    }
  };
  var handleOnClick = function handleOnClick(event) {
    if (!isDisabled) {
      onClick(event);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDisabled ? /*#__PURE__*/_react.default.createElement(ClickableIcon, _extends({}, iconProps, {
    iconName: iconName,
    onClick: handleOnClick,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: tabIndex,
    "aria-label": String(i18n.getText(label)),
    $isDisabled: isDisabled
  })) : /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    label: label
  }, function (ref, providedProps) {
    return /*#__PURE__*/_react.default.createElement(ClickableIcon, _extends({
      ref: ref
    }, providedProps, iconProps, {
      iconName: iconName,
      onClick: handleOnClick,
      className: className,
      onKeyDown: handleKeyDown,
      tabIndex: tabIndex,
      "aria-label": String(i18n.getText(label)),
      $isDisabled: isDisabled
    }));
  }));
}